var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2704 9.18C20.9804 8.72 20.6704 8.29 20.3504 7.89C19.9804 7.42 19.2804 7.38 18.8604 7.8L15.8604 10.8C16.0804 11.46 16.1204 12.22 15.9204 13.01C15.5704 14.42 14.4304 15.56 13.0204 15.91C12.2304 16.11 11.4704 16.07 10.8104 15.85C10.8104 15.85 9.38044 17.28 8.35044 18.31C7.85044 18.81 8.01044 19.69 8.68044 19.95C9.75044 20.36 10.8604 20.57 12.0004 20.57C13.7804 20.57 15.5104 20.05 17.0904 19.08C18.7004 18.08 20.1504 16.61 21.3204 14.74C22.2704 13.23 22.2204 10.69 21.2704 9.18Z",
    fill: "#D4D4D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0196 9.98L9.97965 14.02C9.46965 13.5 9.13965 12.78 9.13965 12C9.13965 10.43 10.4196 9.14 11.9996 9.14C12.7796 9.14 13.4996 9.47 14.0196 9.98Z",
    fill: "#D4D4D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 5.75L14.86 9.14C14.13 8.4 13.12 7.96 12 7.96C9.76 7.96 7.96 9.77 7.96 12C7.96 13.12 8.41 14.13 9.14 14.86L5.76 18.25H5.75C4.64 17.35 3.62 16.2 2.75 14.84C1.75 13.27 1.75 10.72 2.75 9.15C3.91 7.33 5.33 5.9 6.91 4.92C8.49 3.96 10.22 3.43 12 3.43C14.23 3.43 16.39 4.25 18.25 5.75Z",
    fill: "#D4D4D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8601 12C14.8601 13.57 13.5801 14.86 12.0001 14.86C11.9401 14.86 11.8901 14.86 11.8301 14.84L14.8401 11.83C14.8601 11.89 14.8601 11.94 14.8601 12Z",
    fill: "#D4D4D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7699 2.23C21.4699 1.93 20.9799 1.93 20.6799 2.23L2.22988 20.69C1.92988 20.99 1.92988 21.48 2.22988 21.78C2.37988 21.92 2.56988 22 2.76988 22C2.96988 22 3.15988 21.92 3.30988 21.77L21.7699 3.31C22.0799 3.01 22.0799 2.53 21.7699 2.23Z",
    fill: "#D4D4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.a8048de596703eab0948fab4dd35c1dc.svg";
export { ForwardRef as ReactComponent };